import React from 'react'

import Icon from './Icon'

export default class SortableHeader extends React.Component {
    onClick(e) {
        e.preventDefault()
        const { property, sortInfo, onSort } = this.props
        onSort({ 
            orderBy: property, 
            reverseOrder: sortInfo && property === sortInfo.orderBy && !sortInfo.reverseOrder
        })
    }
    render() {
        const { property, title, sortInfo } = this.props
        return (
            <a href="#" onClick={e => this.onClick(e)}>
                {title || property}&nbsp;
                {sortInfo && sortInfo.orderBy === property && 
                    <Icon icon={`sort-by-attributes${sortInfo.reverseOrder ? '-alt' : ''}`} />
                }
            </a>
        )
    }
}




// WEBPACK FOOTER //
// ./components/SortableHeader.jsx